import React, { useEffect, useState, useRef } from 'react';
import {
  fetchAllTelephonyDetails,
  setTelephonyDirectory,
  telephonyDirectoriesSelector,
} from '../../../servicesSlice';
import { useDispatch, useSelector } from 'react-redux';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  TELEPHONY_DIRECTORY_CREATE,
  TELEPHONY_DIRECTORY_VIEW,
} from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_TELEPHONY,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import DirectoryListTable from './DirectoryListTable';
import {
  activateDirectories,
  deactivateDirectories,
  deleteDirectories,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  ResetFilterList,
  selectedCheckList,
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const DirecoryList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const dispatch = useDispatch();
  const telephonyDirectories = useSelector(telephonyDirectoriesSelector);
  const [telephonyDirectoriesList, setTelephonyDirectoriesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    telephonyDirectories: null,
  });
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dragDisabled = !!searchText || telephonyDirectoriesList?.length <= 1;
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  useEffect(() => {
    setTelephonyDirectoriesList((prevList) => {
      return telephonyDirectories.map((directory) => {
        const isChecked = selectedCheckList(prevList, directory.id);
        return {
          ...directory,
          isChecked,
        };
      });
    });

    setLoading(false);
    setSearchText('');
  }, [telephonyDirectories]);

  const getCheckedItems =
    telephonyDirectoriesList?.filter((directory) => directory.isChecked) || [];

  const listOfDirectoryIds = getCheckedItems?.map((feed) => feed.id);
  const selectedCheckedTelephonyDirectoriesLength = getCheckedItems.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(telephonyDirectoriesList, 'isChecked');
    const filteredRows = await telephonyDirectories.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setTelephonyDirectoriesList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedCheckedTelephonyDirectoriesLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setTelephonyDirectoriesList(ResetFilterList);
    }
  };

  useEffect(() => {
    updateSelectedModule(telephonyDirectoriesList, setActionMenuList, setIsAllSelected);
  }, [telephonyDirectoriesList]);

  useEffect(() => {
    if (loading || telephonyDirectoriesList?.length === 0) return;
    const totalItems = telephonyDirectoriesList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [telephonyDirectoriesList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const onOpenDrawer = (event, type) => {
    if (selectedCheckedTelephonyDirectoriesLength) {
      setTelephonyDirectoriesList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.telephonyDirectories);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      telephonyDirectories: null,
    });
  };

  const onClickRowViewDetails = (telephonyDirectory, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(TELEPHONY_DIRECTORY_VIEW, true, telephonyDirectory);
    }
  };

  const onViewDetails = () => {
    onViewToggle(TELEPHONY_DIRECTORY_VIEW, true, selectedValue.telephonyDirectories);
  };

  const handleCellMenuClick = (event, telephonyDirectory) => {
    if (selectedCheckedTelephonyDirectoriesLength > 1) {
      setShowBulkKebabSelectionAlert(true);
      return;
    } else {
      setSelectedValue({
        id: telephonyDirectory.id,
        name: '',
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        telephonyDirectories: telephonyDirectory,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onActiveDeActiveDirectories = async (e, type) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      e.preventDefault();
      if (type) {
        await deactivateDirectories(selectedValue.id, hotelId, language);
      } else {
        await activateDirectories(selectedValue.id, hotelId, language);
      }
      dispatch(fetchAllTelephonyDetails(hotelId));
      notificationManager(
        'success',
        `Directory ${type ? 'deactivated' : 'activated'} successfully`,
      );
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : `Directory not ${type ? 'deactivate' : 'activate'}`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onClickDeleteDirectories = (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      name: prev?.telephonyDirectories?.name,
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
    }));
  };

  const onDelete = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (selectedValue && selectedValue?.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        await deleteDirectories(selectedValue.id, hotelId, language);
        dispatch(fetchAllTelephonyDetails(hotelId));
        notificationManager('success', 'Directory deleted successfully');
      }
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Unable to delete directory',
      );
      handleClose();
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    handleClose();
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleAction = (actionName) => {
    let selectedValue = telephonyDirectoriesList?.filter((tel) => tel?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setTelephonyDirectoriesList(
      telephonyDirectories.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const onApiCallConfirmationMessage = `${
    listOfDirectoryIds.length > 1 ? 'Directories' : 'Directory'
  } ${isActive ? 'activated' : 'deactivated'} successfully.`;

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'TELEPHONY_DIRECTORY';
      await updateSelectedItemsStatus(
        listOfDirectoryIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllTelephonyDetails(hotelId));
      notificationManager('success', onApiCallConfirmationMessage);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Directory was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setTelephonyDirectoriesList(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'TELEPHONY_DIRECTORY';
      await deleteSelectedItems(
        listOfDirectoryIds,
        hotelId,
        selectedLang,
        moduleName,
        '',
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllTelephonyDetails(hotelId));
      notificationManager('success', 'Directory deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Directory',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <SearchBar
        type={TELEPHONY_DIRECTORY_CREATE}
        buttonName='Add Number'
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_TELEPHONY] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? 'show'
            : 'hide'
        }
        filterList={[]}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={telephonyDirectoriesList}
        setPlaceHolder={setTelephonyDirectoriesList}
        globalPlaceHolder={telephonyDirectories}
        setGlobalPlaceHolder={setTelephonyDirectory}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Telephony directory'
        module='TELEPHONY_DIRECTORY'
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <DirectoryListTable
          page={page}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          permissions={permissions}
          handleCellMenuClick={handleCellMenuClick}
          telephonyDirectoriesList={telephonyDirectoriesList}
          setTelephonyDirectoriesList={setTelephonyDirectoriesList}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onActiveDeActiveDirectories={onActiveDeActiveDirectories}
          onDeleteDirectories={onClickDeleteDirectories}
          setVisible={setVisible}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          actionMenuList={actionMenuList}
          setActionMenuList={setActionMenuList}
          selectedCheckedTelephonyDirectoriesLength={selectedCheckedTelephonyDirectoriesLength}
          setShowBulkSearchAlert={setShowBulkSearchAlert}
          telephonyDirectories={telephonyDirectories}
          dragDisabled={dragDisabled}
        />
      </div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCheckedTelephonyDirectoriesLength} ${
            selectedCheckedTelephonyDirectoriesLength > 1 ? 'directories' : 'directory'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCheckedTelephonyDirectoriesLength}  ${
            selectedCheckedTelephonyDirectoriesLength > 1 ? 'directories' : 'directory'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
    </div>
  );
};

export default DirecoryList;
